<div class="flex flex-col gap-medpace">
    <mds-expansion-panel
        [panelTitle]="formGroup().controls.patientPassportInfo.title"
        [description]="'Passport Information'"
        class="expansion-panel-patient-passport-info"
    >
        <medpace-passport-info [mode]="mode()" [formGroup]="formGroup().controls.patientPassportInfo" />
    </mds-expansion-panel>

    @for (passportInfoFormGroup of formGroup().controls.caregiverPassportInfos.controls; track passportInfoFormGroup) {
        <mds-expansion-panel
            [panelTitle]="passportInfoFormGroup.title"
            [description]="'Passport Information'"
            class="expansion-panel-caregiver-passport-info"
        >
            <medpace-passport-info [mode]="mode()" [formGroup]="passportInfoFormGroup" />
        </mds-expansion-panel>
    }
</div>
